import { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import Detail from "../../../main/detail/Detail";
import { rsActiveMenu, rsProgress, rsParentCom } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseProduct4 } from "./UseProduct4";
import ProductOfferFrame from "./ProductOfferFrame";
import GroupsGrid from "./Group/GroupsGrid";

export default function Product4(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const location = useLocation();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { ProductOffer } = UseProduct4();
  const [offers, setOffers] = useState();
  const [msParentCom, setMsParentCom] = useRecoilState(rsParentCom);

  useEffect(() => {
    setProgress(true);
    ProductOffer(location.state.OfferID, (callback) => {
      setOffers(callback);
    });
  }, [location.state]);

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        backURL: msParentCom.backUrl,
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: msParentCom.parentComs },
          {
            name: "مدیریت" + " " + location.state.componentFaTitle,
            url: "/ProductsOfferManage",
          },
        ],
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box>
          <Typography color="secondary" sx={{ mb: 1 }} variant="subtitle1">
            فریم نمایش
          </Typography>
          <ProductOfferFrame
            OfferID={offers && offers.id}
            aid={location.state.OfferID}
            offers={offers && offers}
            callback={() => {
              setProgress(true);
              ProductOffer(location.state.OfferID, (callback) => {
                setOffers(callback);
              });
            }}
          />
        </Box>
        <Box sx={{ mt: 2 }}>
          <Typography color="secondary" sx={{ mb: 1 }} variant="subtitle1">
            گروه ها
          </Typography>
          <GroupsGrid
            thisOfferId={offers && offers.id ? offers.id : undefined}
            OfferID={offers && offers.id}
            rows={offers && offers.groups}
            offers={offers && offers}
            setOffers={setOffers}
            componentAID={location.state.OfferID}
            callback={() => {
              ProductOffer(location.state.OfferID, (callback) => {
                setOffers(callback);
              });
            }}
          />
        </Box>
      </Box>
    </Detail>
  );
}
